import { ReactElement, useEffect, useState } from 'react'
import style from './index.module.less'
import logo from '@imgs/logo.png'
import { Button, Input, Toast } from 'antd-mobile'
import { validateRequest, getListRequest, DataSchema, clickRequest } from './ajax'
import { awaitWrap } from '@src/assets/js/tool'
import { useDispatch, useSelector } from 'react-redux'
import { setVideoCheck } from '@src/redux/actions/basic'
import { BASIC_STATE } from '@src/redux/reducers/basic'
import classNames from 'classnames'
import { useHistory } from 'react-router-dom'

async function validateHandle (code: string, callback: () => void): Promise<void> {
  Toast.show({ content: '提交中', icon: 'loading', duration: 0 })
  const [e] = await awaitWrap(validateRequest(code))
  if (e === null) {
    Toast.clear()
    callback()
  }
}

async function initList (setList: (v: DataSchema[]) => void): Promise<void> {
  const [e, d] = await awaitWrap(getListRequest())
  if (e === null && d !== null) {
    setList(d)
  }
}

async function clickHandle (name: string, id: string): Promise<void> {
  const [e] = await awaitWrap(clickRequest(id, name))
  if (e === null) {
    return undefined
  }
}

async function confirm (code: string, callback: () => void): Promise<void> {
  if (code === '') {
    Toast.show('验证码不能为空')
  } else if (code.length < 4) {
    Toast.show('验证码格式不正确')
  } else {
    validateHandle(code, callback).then(null, null)
  }
}

function Item ({ i, data }: { i: number, data: DataSchema }): ReactElement {
  const [active, setActive] = useState(false)
  const h = useHistory()
  return (
    <div className={classNames(style.li, { [style.active]: active })} onClick={() => {
      setActive(true)
      setTimeout(() => {
        setActive(false)
        clickHandle(data.id, data.name).then(null, null)
        if (data.type === 'pdf') {
          window.open(data.url, '_blank')
        } else {
          h.push(`/video?title=${data.name}&url=${data.url}`)
        }
      }, 300)
    }}>
      <span>
        {i + 1}.{data.name}
      </span>
      <span className={style['video-icon']}></span>
    </div>
  )
}

function Main (): ReactElement {
  const [code, setCode] = useState('')
  const dispatch = useDispatch()
  const checked = useSelector((s: { basic: BASIC_STATE }) => s.basic.videoCheck)
  const [list, setList] = useState<DataSchema[]>([])
  useEffect(() => {
    if (checked) {
      initList(setList).then(null, null)
    }
  }, [checked])
  return (
    <div className={style.container}>
      <div className={style.title}>
        <img src={logo} className={style.logo} />
        <span>厦门仲裁委员会/厦门国际仲裁院</span>
      </div>
      {
        !checked && (
          <div>
            <div className={style.confirm}>
              <div className={style['confirm-title']}>观看30周年发布视频</div>
              <div className={style['input-box']}>
                <Input placeholder='请输入验证码' className={style.input} value={code} onChange={e => setCode(e)} maxLength={4} />
              </div>
            </div>
            <div className={style.submit}>
              <Button block color='primary' size='large' onClick={async () => { await confirm(code, () => { dispatch(setVideoCheck(true)) }) }}>进入观看视频</Button>
            </div>
          </div>
        )
      }
      {
        checked && (
          <div className={style.list}>
            {
              list.map((li, i) => {
                return (
                  <Item i={i} data={li} key={i} />
                )
              })
            }
          </div>
        )
      }
    </div>
  )
}

export default Main
